import state from './moduleRatePlanPolicyManagementState.js'
import mutations from './moduleRatePlanPolicyManagementMutations.js'
import actions from './moduleRatePlanPolicyManagementActions.js'
import getters from './moduleRatePlanPolicyManagementGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

